import { render, staticRenderFns } from "./heroHomepageArrow.vue?vue&type=template&id=587d2f36&"
import script from "./heroHomepageArrow.vue?vue&type=script&lang=js&"
export * from "./heroHomepageArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587d2f36')) {
      api.createRecord('587d2f36', component.options)
    } else {
      api.reload('587d2f36', component.options)
    }
    module.hot.accept("./heroHomepageArrow.vue?vue&type=template&id=587d2f36&", function () {
      api.rerender('587d2f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepageArrow.vue"
export default component.exports